import Keycloak from 'keycloak-js'
import Configuration from './Api/Configuration'

const { Keycloak_Config } = Configuration
// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak(Keycloak_Config)

export default keycloak
